module.exports = __webpack_public_path__ + "img/no-data.da8f3373.png";